import { schema } from 'normalizr';

export const groupFieldSchema = new schema.Entity('groupField');
